module.exports = __webpack_public_path__ + "img/roses.4c342cc9.jpeg";